import PAAttendee from "./Attendee";



class AccountDocument {
    constructor() {
        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;

        this.created = 0;

        this.created_by = "";
        this.attendee_id = ""; // The owner
        this.name = "";
        this.pages = [];
        this.cid_hash = "";
        this.data = "";
        this.data_category = "";
        this.encrypted_data = [];
        this.file_name = "";
        this.file_type = "";
        this.file_size = "";
        this.width = 0;
        this.height = 0;
        this.file_location = "";
        this.categories = [];
        this.private = true;
        this.encrypted = false;
        this.passcode_needed = false;
        this.key = {};
        this.salt = {};
        this.iv = {};
        this.gcs_blob_id = "";
        this.gcs_blob_file_name = "";
        this.events = [];
        this.expires = "";
        this.last_accessed = 0;
        this.notes = "";
        this.status = 1;    //1=account, 2=event
    }

    setEntireDocument(_id, _created, _name, _pages, _cid_hash, _file_data, _encrypted_data, _file_name, _file_type, _file_size, _width, _height, _file_location, _categories,
                      _private, _encrypted, _passcode_needed, _key, _salt, _iv, _gcs_blob_id, _gcs_blob_file_name, _events, _expires, _last_accessed, _notes, _status) {
        this.id = _id;
        this.created = _created;
        this.name = _name;
        this.pages = _pages;
        this.cid_hash = _cid_hash;
        this.data = _file_data;
        this.encrypted_data = _encrypted_data;
        this.file_name = _file_name;
        this.file_type = _file_type;
        this.file_size = _file_size;
        this.width = _width;
        this.height = _height;
        this.file_location = _file_location;
        this.categories = _categories;
        this.private = _private;
        this.encrypted = _encrypted;
        this.passcode_needed = _passcode_needed;
        this.key = _key;
        this.salt = _salt;
        this.iv = _iv;
        this.gcs_blob_id = _gcs_blob_id;
        this.gcs_blob_file_name = _gcs_blob_file_name;
        this.events = _events;
        this.expires = _expires;
        this.last_accessed = _last_accessed;
        this.notes = _notes;
        this.status = _status;
    }

    setPartialDocument(_id, _created, _name, _data, _file_name, _file_type, _file_size, _width, _height, _categories, _private, _encrypted, _passcode_needed,
                       _events, _expires, _last_accessed, _notes, _status){
        this.id = _id;
        this.created = _created;
        this.name = _name;
        this.data = _data;
        this.file_name = _file_name;
        this.file_type = _file_type;
        this.file_size = _file_size;
        this.width = _width;
        this.height = _height;
        this.categories = _categories;
        this.private = _private;
        this.encrypted = _encrypted;
        this.passcode_needed = _passcode_needed;
        this.events = _events;
        this.expires = _expires;
        this.last_accessed = _last_accessed;
        this.notes = _notes;
        this.status = _status;
    }

}

export default AccountDocument;